import { render, staticRenderFns } from "./XScroll.vue?vue&type=template&id=31a8afc7&scoped=true&"
import script from "./XScroll.vue?vue&type=script&lang=js&"
export * from "./XScroll.vue?vue&type=script&lang=js&"
import style0 from "./XScroll.vue?vue&type=style&index=0&id=31a8afc7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a8afc7",
  null
  
)

export default component.exports